import React, { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import Button from '@material-ui/core/Button';

import styles from './NavigationButton.module.css';

export default function NavigationButton({
  onClick,
  isNext,
  alignRight,
  alignLeft,
  disabled,
}: {
  onClick: MouseEventHandler<HTMLButtonElement>;
  isNext?: boolean;
  alignRight?: boolean;
  alignLeft?: boolean;
  disabled?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <div
      className={`${styles.container} ${
        alignRight ? styles.alignRightContainer : ''
      } ${alignLeft ? styles.alignLeftContainer : ''}`}
    >
      <Button
        onClick={onClick}
        startIcon={!isNext ? <MdNavigateBefore /> : undefined}
        endIcon={isNext ? <MdNavigateNext /> : undefined}
        className="text-xl font-bold"
        disabled={disabled}
      >
        {isNext ? t('shared.buttons.next') : t('shared.buttons.back')}
      </Button>
    </div>
  );
}

NavigationButton.defaultProps = {
  isNext: false,
  alignRight: false,
  alignLeft: false,
  disabled: false,
};
